export default __webpack_public_path__ + "static/media/02 Welcome Screen – 1@2x.badd8845.png";